const EL = '.js-DoctorsCarousel'
const IS_FINE = matchMedia('(pointer:fine)').matches

import Splide from '@splidejs/splide';

if(IS_FINE && document.querySelector(EL)){
  const items = document.querySelectorAll(EL)

  items.forEach(item => {
    const isProcedureCarousel = item.closest('.landing-procedure-doctors')

    new Splide( item, {
      autoWidth: true,
      pagination: false,
      padding: isProcedureCarousel ? 0 : { left: (window.innerWidth - 1200) / 2 - 40},
      perPage: 4,
      perMove: 2,
      arrowPath: 'M17.5115243,18 L22.4884885,18 C22.7709885,18 23,18.2284852 23,18.5103359 C23,18.6297221 22.9580478,18.7453299 22.8814425,18.837045 L20.3929604,21.8163604 C20.2121083,22.0328841 19.8895672,22.0621386 19.6725447,21.8817022 L19.6070524,21.8163604 L19.6070524,21.8163604 L17.1185703,18.837045 C16.9377182,18.6205212 16.9670401,18.2987214 17.1840626,18.118285 C17.2759889,18.0418558 17.3918631,18 17.5115243,18 Z'
    } ).mount();
  })
}
